import React, { useEffect, useRef } from 'react';
import './report.scss';

import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import fileDownload from 'js-file-download';
import {
  responseLogWithNotification, useFilterForm,
  useUpdatePeriod,
} from '../../../utils/utils';
import { loadStatisticsData } from '../actions';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getStatisticsData } from '../reducer';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import {
  Button, Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import ApexBarChart from '../../../components/charts/ApexBarChart';
import { loadFileByUrl } from '../../System/actions';
import { BACKEND_URL, DEFAULT_CHART_COLORS } from '../../../configs';
import {
  createStatisticsTooltip,
  normalizeStatisticsChartData,
} from './statisticsChartData';

function StatisticsChartCard({
  title,
  chart = {},
  total = 0,
  loading = false,
}) {
  const chartData = normalizeStatisticsChartData(chart);

  return (
    <div className="statistics-chart-card">
      <div className="statistics-card-header">
        <div className="statistics-card-title">{title}</div>
        <div className="statistics-card-total">{total}</div>
      </div>
      <ApexBarChart
        {...chartData}
        title=""
        className="dashboard-stat-chart statistics-provider-chart"
        loading={loading}
        colors={DEFAULT_CHART_COLORS}
        tooltipCustom={createStatisticsTooltip(chartData.labels, chartData.totals)}
        emptyText={chartData.emptyText}
      />
    </div>
  );
}

export default function StatisticsPage() {
  const blockRef = useRef(null);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const { updatePeriod } = useSelector(getSystemData);
  const { loadingStatisticsData, statisticsData } = useSelector(getStatisticsData);
  const loadData = () => {
    const requestData = {
      filter: getValues(),
    };
    const p1 = dispatch(loadStatisticsData(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    created_at_from: defaultDate[0], created_at_to: defaultDate[1], search: '', created_at: '',
  };
  const { getValues, control, setValue } = useFilterForm(defaultFilterValues, loadData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const handleLoadReport = () => {
    dispatch(loadFileByUrl(`${BACKEND_URL}/export/statistics/excel`))
      .then(data => {
        if (data) {
          fileDownload(data, data.filename);
        }
      })
      .catch(responseLogWithNotification);
  };

  const handleLoadPdfReport = () => {
    dispatch(loadFileByUrl(`${BACKEND_URL}/export/statistics/pdf`))
      .then(data => {
        if (data) {
          fileDownload(data, data.filename);
        }
      })
      .catch(responseLogWithNotification);
  };

  return (
    <div className="page application-page statistics-page">
      <Loader loading={loadingStatisticsData} global hideScreen />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.statistics' })}</div>
        <FilterRow>
          <Button onClick={handleLoadReport}>
            <Icons icon="download" width={16} height={16} />
            Скачать xlsx
          </Button>
          <Button onClick={handleLoadPdfReport}>
            <Icons icon="download" width={16} height={16} />
            Скачать pdf
          </Button>
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <Row>
            <Col columns={12}>
              <StatisticsChartCard
                title="Статистика ТС по районам"
                chart={statisticsData?.vehicle_chart}
                total={statisticsData?.total_vehicles || 0}
                loading={loadingStatisticsData}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col columns={12}>
              <StatisticsChartCard
                title="Статистика нарушений по районам"
                chart={statisticsData?.violation_chart}
                total={statisticsData?.total_violations || 0}
                loading={loadingStatisticsData}
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
